import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AdminProjectDetail from "../components/AdminProjectDetail";
import * as actions from "../../../../../actions/project.actions";
import * as adminActions from "../../../../../actions/admin.actions";
import * as commonActions from "../../../../../actions/common.actions";

const rejectedHeader = () => ({
  color: "strongGrey",
  title: "Project successfully rejected"
});

const subHeader = (projectId, totalMatches) => {
  return {
    items: [
      {
        caption: "Project Detail",
        url: `/admin/project/${projectId}/detail`
      },
      {
        caption: `Potential Matches (${totalMatches})`,
        url: `/admin/project/${projectId}/potential-matches`
      }
    ],
    activeItem: 0
  };
};

const approvedSubHeader = (projectId, totalMatches, totalPitches) => {
  return {
    items: [
      {
        caption: "Project Detail",
        url: `/admin/project/${projectId}/detail`
      },
      {
        caption: `Matches (${totalMatches})`,
        url: `/admin/project/${projectId}/matches`
      },
      {
        caption: `Pitches (${totalPitches})`,
        url: `/admin/project/${projectId}/pitches`
      },
      {
        caption: "SOW",
        url: `/admin/project/${projectId}/sow`
      },
      {
        caption: "Reviews",
        url: `/admin/project/${projectId}/reviews`
      }
    ],
    activeItem: 0
  };
};

class AdminProjectDetailContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentProjectState: null
    };
  }

  componentDidMount() {
    this.props.actions.getStatus();
    this.props.adminActions.getProject(
      this.props.match.params.projectId,
      "?potential=true"
    );
    this.props.adminActions.getProjectFeed(this.props.match.params.projectId);
  }

  componentDidUpdate(prevProps, prevState) {
    this.setHeaderBar(prevState);
  }

  setHeaderBar(prevState) {
    const project = this.props.project;
    const status = _.get(project, "status.name");

    let totalMatches = 0;
    let totalPitches = 0;

    let headerBar = {};
    let selectedSubHeader = {};
    let currentProjectState = status;

    if (status != undefined) {
      switch (status) {
        case "draft":
        case "submitted-for-approval":
          totalMatches = _.get(project, "stats.matches.potential");
          selectedSubHeader = subHeader(project.id, totalMatches);
          break;

        case "rejected":
          totalMatches = _.get(project, "stats.matches.matched");
          selectedSubHeader = subHeader(project.id, totalMatches);
          headerBar = rejectedHeader();
          break;

        default:
          totalMatches = _.get(project, "stats.matches.matched");
          totalPitches =
            _.get(project, "stats.pitches.accepted") +
            _.get(project, "stats.pitches.pending");
          selectedSubHeader = approvedSubHeader(
            project.id,
            totalMatches,
            totalPitches
          );
          break;
      }
    }

    if (currentProjectState !== prevState.currentProjectState) {
      this.props.commonActions.setHeaderBar(headerBar);
      this.props.commonActions.setSubHeader(selectedSubHeader);
      this.setState({ currentProjectState });
    }
  }

  componentWillUnmount() {
    this.props.commonActions.setHeaderBar({});
    this.props.commonActions.setSubHeader({});
  }

  render() {
    return (
      <AdminProjectDetail
        projectData={this.props.project}
        projectFeed={this.props.feed}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    project: state.admin.project,
    feed: state.admin.feed
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    adminActions: bindActionCreators(adminActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminProjectDetailContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/project/detail/containers/AdminProjectDetailContainer.js